import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/E3_favorite_star.svg'

const E3FavoriteStar: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 30 30'} component={Icon} {...props} fill="currentColor" />
export default E3FavoriteStar
